import ExpertProfilePortfolioEditModalModule from './expert-profile-portfolio-edit-modal.module'

export default ExpertProfilePortfolioEditModalModule
